export default function calculateComposite(data) {
  const {
    totalGPA = 0,             // 0–4
    avgGPA = 0,               // 0–4 (reference average)
    passRate = 0,             // 0–1
    projectedDifficulty = 3,  // 1–5 (higher = harder)
    progressSlope = 0         // trend; roughly -1 to +1
  } = data || {};

  // Helpers
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const scale01 = (v, min, max) => (clamp(v, min, max) - min) / (max - min);
  const inv01 = (v) => 1 - clamp(v, 0, 1);
  const tanh01 = (x, k = 0.75) => (Math.tanh(k * x) + 1) / 2;

  // Individual 0–1 scores
  const totalGPA_score = scale01(totalGPA, 0, 4);
  const avgGPA_score = scale01(avgGPA, 0, 4);
  const passRate_score = clamp(passRate, 0, 1);
  const difficulty_score = inv01(scale01(projectedDifficulty, 1, 5)); // harder → lower
  const progressSlope_score = tanh01(progressSlope, 0.75);             // trend smoothed

  // Weights sum to 1
  const weights = {
    totalGPA: .5,
    avgGPA: 0.145,
    passRate: 0.1,
    difficulty: 0.25,
    progressSlope: 0.05
  };

  const composite01 =
    weights.totalGPA * totalGPA_score +
    weights.avgGPA * avgGPA_score +
    weights.passRate * passRate_score +
    weights.difficulty * difficulty_score +
    weights.progressSlope * progressSlope_score;

  const composite10 = +(clamp(composite01, 0, 1) * 10).toFixed(2);

  return composite10;
}
